import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appDisabledUi]',
    standalone: true,
})
export class DisabledUiDirective {
    @Input('appDisabledUi')
    set appDisabledUi(value: boolean | string | null | undefined) {
        this.isDisabled = coerceBooleanProperty(value);
    }

    @HostBinding('style.pointer-events')
    get hostPointerEvents(): 'none' | null {
        return this.isDisabled ? 'none' : null;
    }

    @HostBinding('style.opacity')
    get hostOpacity(): '0.6' | null {
        return this.isDisabled ? '0.6' : null;
    }

    @HostBinding('attr.aria-disabled')
    get hostAriaDisabled(): 'true' | 'false' {
        return this.isDisabled ? 'true' : 'false';
    }

    @HostBinding('attr.disabled')
    get hostDisabled(): '' | null {
        return this.isDisabled ? '' : null;
    }

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        if (!this.isDisabled) {
            return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
    }

    private isDisabled = false;
}

